import { useModal } from "@ebay/nice-modal-react";
import { Skeleton } from "@mui/material";
import Grid from "@mui/material/Grid";
import useQueryStringState from "components/hooks/useQueryStringState";
import { EditButton } from "components/ui/atoms/Button";
import Layout from "components/ui/molecules/Layout";
import TimeLine from "models/actions/Timeline";
import ContactWidget from "models/contacts/ContactWidget";
import { useLogHistory } from "models/history/apiHistory";
import NoteWidget from "models/notes/NoteWidget";
import PeopleHeader from "models/people/PeopleHeader";
import PeopleView from "models/people/PeopleView";
import { usePeople } from "models/people/apiPeople";
import SociaPeopleWidget from "models/social/SocialPeopleWidget";
import { useEffect } from "react";
import { useParams } from "react-router-dom";

const PeopleDetail = ({}) => {
  const { people_id } = useParams();
  const [state, setState] = useQueryStringState();
  const {
    data: people,
    isLoading,
    isError,
    isSuccess,
    error,
  } = usePeople(people_id);
  const handleLog = useLogHistory("app.people");
  const peopleModal = useModal("PeopleDrawer");

  useEffect(() => {
    isSuccess && handleLog(people.id);
  }, [isSuccess, people?.id]);

  if (isLoading) return <Skeleton variant="rectangular" height={150} />;
  if (isError) return <>{error.message}</>;

  return (
    <Layout container hideBreadcrumbs>
      <Layout title variant="component">
        <PeopleHeader people={people} />
      </Layout>
      <Layout content>
        <Grid container spacing={2}>
          <EditButton
            onClick={() =>
              peopleModal.show({ id: people.id, formType: "update" })
            }
          />
          <Grid size={12}>
            <PeopleView people={people} />
          </Grid>
          <Grid size={{ xs: 12, md: 6 }}>
            <ContactWidget peopleId={people.id} />
          </Grid>
          <Grid size={{ xs: 12, md: 6 }}>
            <NoteWidget peopleId={people.id} />
          </Grid>
          <Grid size={{ xs: 12, md: 6 }}>
            <SociaPeopleWidget peopleId={people.id} />
          </Grid>
        </Grid>
      </Layout>
      <Layout content>
        <TimeLine
          peopleAddresses={people.email_addresses}
          state={state.timeline || {}}
          setState={(innerState) =>
            setState({ ...state, timeline: innerState })
          }
        />
      </Layout>
    </Layout>
  );
};

export default PeopleDetail;
